import { render, staticRenderFns } from "./TeacherCreate.vue?vue&type=template&id=37c24dcd"
import script from "../../controllers/teacher/teacher-create.js?vue&type=script&lang=js&external"
export * from "../../controllers/teacher/teacher-create.js?vue&type=script&lang=js&external"
import style0 from "./TeacherCreate.vue?vue&type=style&index=0&id=37c24dcd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports